import { defineStore } from "pinia";
import { ref, computed } from "vue";

export const useThemeStore = defineStore("theme", () => {
  const isDark = ref(false);

  // Initialize theme from localStorage or system preference
  const initTheme = () => {
    const savedTheme = localStorage.getItem("jukebox_theme");
    if (savedTheme) {
      isDark.value = savedTheme === "dark";
    } else {
      // Check system preference
      isDark.value = window.matchMedia("(prefers-color-scheme: dark)").matches;
    }
    applyTheme();
  };

  // Apply theme to document
  const applyTheme = () => {
    if (isDark.value) {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }
    localStorage.setItem("jukebox_theme", isDark.value ? "dark" : "light");
  };

  // Toggle theme
  const toggleTheme = () => {
    isDark.value = !isDark.value;
    applyTheme();
  };

  // Set theme based on event theme (overrides user preference for event pages)
  const setEventTheme = (eventTheme) => {
    if (eventTheme === "dark" || eventTheme === "light") {
      isDark.value = eventTheme === "dark";
      applyTheme();
    }
  };

  // Computed property for logo source
  const logoSrc = computed(() => {
    return isDark.value ? "/logo/jbc-logo-dark.webp" : "/logo/jbc-logo-light.webp";
  });

  return {
    isDark,
    logoSrc,
    initTheme,
    toggleTheme,
    setEventTheme
  };
});
